<template>
  <div id="login">
    <div class="login-logo">
      <img src="../assets/img/logo_s.png"/>
      <span style="display: inline-block;margin-left:10px;" v-html="gname"></span>
    </div>
    <div class="chose-chrome">
      <h2>推荐设备说明</h2>
      <dl>
        <dt>六六脑是严肃、专业的脑认知训练系统，为确保系统稳定性和训练效果，请您确保使用以下2类推荐设备：</dt>
        <dd>•电脑，包含一体机。如果您使用Windows系统的电脑（配置要求：操作系统64位），请使用<span class="bold-mark">Chrome</span>浏览（<a id="download" class="link-mark" href="https://www.66nao.com/faq/source_package/chrome.rar">点击下载</a>，查看<a class="link-mark" href="https://www.66nao.com/faq/pages/question.1.html" target="_blank">下载安装说明</a>。如果您在使用Chrome浏览器时无法正常训练，请尝试卸载后重新安装我们提供的Chrome浏览器。）；如果是macOS系统，请使用自带的<span class="bold-mark">Safari</span>浏览器 。​</dd>
        <dd>•平板，推荐苹果 <span class="bold-mark">iPad2017</span> 和 <span class="bold-mark">iPad2018</span> 。请使用设备自带的<span class="bold-mark">Safari</span>浏览器 。</dd>
        <dt>注：手机、安卓平板等设备因屏幕小、型号多，易造成不可控的稳定性和使用问题，不建议使用。</dt>
      </dl>
    </div>
    <mu-paper class="demo-paper" :zDepth="1">
      <div class="login-title">
        <div class = 'login-tm'><img src="../../static/images/logo-font.png" /></div>
        <div class = 'login-terminal'><div>|</div>医生登录</div>
      </div>
      <div class="login-content">
        <div>
          <mu-text-field v-model="user.username" hintText="登录名/手机号"  />
        </div>
        <div>
          <mu-text-field v-model="user.password" type="password" hintText="密码"  />
        </div>
        <div class="danger" v-show="hasSubmitted && !isValid">{{error}}</div>
        <div class="danger" v-show="authError">{{errorMessage}}</div>
        <div>
          <mu-raised-button label="登录" class="demo-raised-button" @click="login" primary/>
        </div>
      </div>

      <div class="login-forget"><router-link to="/reset" style="color:#999;">忘记密码</router-link>&nbsp;|&nbsp;<a href="https://www.66nao.com/faq/" target="_blank" style="color:rgb(153, 153, 153);">常见问题</a></div>
    </mu-paper>

  </div>
</template>
<script>
  import Vue from 'vue'
  import {applyRouteTemplate} from '../router/utils.js'
  import {getData,postData} from '../assets/js/common.js'
  var store = require('./store.js');
  export default {
    data: function () {
      return {
        // gname: GLOBAL.NAME,
        gname: "",
        user: {
          'grant_type': 'password',
          username: '',
          password: '',
          'client_id': 'wispirit',
          'client_type': 'doctor',
          expire_day:5,
        },
        hasSubmitted: false,
        authError: false,
        errorMessage: '',
        next_route: '',

      }
    },

    computed: {
      validation: function () {
        return {
          username: !!this.user.username.trim(),
          password: !!this.user.password.trim()
        }
      },
      isValid: function () {
        var validation = this.validation
        return Object.keys(validation).every(function (key) {
          return validation[key]
        })
      },
      error: function() {
        if (!this.validation.username) {
          return '手机号不能为空';
        }
        if (!this.validation.password) {
          return '密码不能为空';
        }
      }
    },

    watch: {
      user: {
        deep: true,
        handler: function () {
          this.hasSubmitted = false;
          this.authError = false;
        }
      }
    },
    created(){
      this.bkCheckAutoLogin();
    },
    methods: {
      getUserMe(token){
        return new Promise((res,rej) => {
          getData('/api/Users/me', function(){
            res(JSON.parse(arguments[0]));
          },token)
        })
      },
      postLogin(data){
        return new Promise((res,rej) => {
          postData('/api/Auth/login', data, function(){
            // res(JSON.parse(arguments[0]))  #陈code
            let result = JSON.parse(arguments[0]);  //# dkal code
            if("error" in result){
              rej(result);
            }else{
              res(result);
            }
          })
        })
      },
      bkCheckAutoLogin(){
        this.getUserMe().then(
          (res) => {
            if(res.resultCode == 20000){
              // self.$router.push({name:"home"});
              window.location.href="/#/dashboard/homepage";
            }else{
              this.$router.push({name:"login"});
            }
          }
        );
      },
      getAccount: function () {
        var token = localStorage.getItem('access_token');
        if (token) {
          return this.$http.get('/api/Users/me').then(
            function (res) {
              store.setAccount(res.data);
            },
            function(res){
              console.log(res)
            }
          );
        }
      },

      login: function (event) {
        GLOBAL.login_count = 0;
        event.preventDefault();
        var self  = this;
        self.hasSubmitted = true;
        if (self.isValid) {
          self.postLogin(self.user)
          //判断登录是否成功
          .then(
            function (res) {
              if(res.resultCode == 50000){
                self.authError = true;
                self.errorMessage = res.resultMsg;
                return true;
              }
              localStorage.setItem("access_token", res.access_token);
              localStorage.setItem('refresh_token', res.refresh_token);
              if (res.status === '1') {
                self.next_route = { path: '/active' };
              }  else {
                self.next_route = { path: '/dashboard/homepage', query: { from_login: 'true' } };
              }
              return true;
            },
            function(res) {
              self.authError = true;
              if(res.resultCode == 50000){
                self.errorMessage = res.resultMsg;
              }
              if (res.status === 401 || res.status!==200) {//# dkal code
                self.errorMessage = '用户名或密码错误';
              }
              return false;
            }
          )
          //获取路由
          .then( is_login =>
          {
            if (false == is_login)
            {
              return false;
            }
            var apiUrl = `/api/v2/users/${this.user.username}/available-routes/doctor`;
            return this.$http.get(apiUrl);
          })
          //组装路由并跳转
          .then((res)=>
          {
            if (false == res)
            {
              return;
            }
            let new_routes = res.data;
            let brainStatus = { path: '/brainStatus/:id', component: "brainStatus", name:'brainStatus' };
            /* let errorPage={path:'/errorPage',component:'errorPage',name:'errorPage'};
            let noPage = {path: '*', component: "noPage", name: "noPage"};
            let timeoutPage = {path: '*', component: "timeoutPage", name: "timeoutPage"}; */
            new_routes[0].children[1].children.push(brainStatus);
            /* new_routes.push(timeoutPage);
            new_routes.push(errorPage);
            new_routes.push(noPage); */
            applyRouteTemplate(new_routes);
            self.$router.addRoutes(new_routes);
            return self.getAccount();
          }).then(_1 =>
          {
            self.$router.push(self.next_route);
          });
        } else {

        }
      },
      checkSystem(){
        //js判断是否ios或Android
        let u = navigator.userAgent;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let a = document.getElementById("download");
        if (isAndroid) {
            a.href ="https://www.66nao.com/faq/source_package/com.android.chrome.apk";
        } else if (isiOS){
            a.href = "javascript:void(0)";
        } else{
            //不做操作
        }
      }
    },
    mounted(){
      let system_name = `六六脑<sup>&#174;</sup>&nbsp;&nbsp;${window.g_system_preferences.name}`;
      this.gname = system_name;
      this.checkSystem();
      this.$forceUpdate();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset;
  }
  ::-webkit-input-placeholder {
    text-align: center;
  }
  .login-logo {
    color: #ffffff;
    font-size: 22px;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    position: absolute;
    left: 25px;
    top: 30px;

  }
  #login {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: #0a81e5;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .demo-paper {
    display: inline-block;
    height: 400px;
    width: 350px;
    text-align: center;
  }
  .login-title {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding-left: 60px;
    padding-right: 60px;
    margin-top: 60px;
    font-size: 22px;
    color: #999;
  }
  .login-tm {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #0a81e5;
  }
  .login-terminal {
    display: flex;
    justify-content: center;
  }
  .login-content {
    margin-top: 40px;
  }
  .demo-raised-button {
    margin-top: 25px!important;
    border-radius:30px!important;
    width:250px;
    height:40px!important;
    background-color: #0a81e5!important;
  }
  .login-forget {
    margin-top:30px;
    color: #999999!important;
    font-size: 14px;
    text-decoration: underline;
  }
  .chose-chrome{
    width:600px;
    height:400px;
    background-color:#eee;
    padding:30px;
    margin-right:30px;
    border-radius:3px;
  }
  .chose-chrome h2{
    text-align:center;
  }
  .chose-chrome dl dt,.chose-chrome dl dd{
    line-height:30px;
  }
  .bold-mark{
    font-weight:bold;
  }
  .link-mark{
    color:rgb(0,0,255);
    text-decoration:underline;
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// login.vue?c333bbde